import './assets/main.css'

// axios

import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;
axios.interceptors.response.use(
  response => response,
  (error) => {
    if (
      error.response.status === 401 &&
      error.config.baseURL.includes(import.meta.env.VITE_API_BASE_URL) &&
      !error.config.url.includes('auth/') &&
      router.currentRoute.value.meta?.auth
    ) {
      localStorage.removeItem('user');
      window.location.href = import.meta.env.VITE_BASE_URL
      return;
    }

    return Promise.reject(error);
  }
)

// echo

import { configureEcho } from "@laravel/echo-vue";

configureEcho({
  broadcaster: 'pusher',
  authEndpoint: `${import.meta.env.VITE_BASE_URL}/broadcasting/auth`,
  key: import.meta.env.VITE_PUSHER_APP_KEY,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  encrypted: true,
  authorizer: (channel) => {
    return {
      authorize: (socketId, callback) => {
        axios.post('/broadcasting/auth', {
          socket_id: socketId,
          channel_name: channel.name
        })
          .then(response => {
            callback(false, response.data);
          })
          .catch(error => {
            callback(true, error);
          });
      }
    };
  },
});

// base app

import {createApp} from 'vue'
import App from './App.vue'
const app = createApp(App)

// sentry

import * as Sentry from "@sentry/vue";

Sentry.init({
  app,
  dsn: "https://959a197a36d2c70ab70639e89276512e@o4510177320960000.ingest.de.sentry.io/4510177364475984",
  sendDefaultPii: true,
  environment: import.meta.env.VITE_ENVIRONMENT || 'production',
  integrations: [
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE
    ? parseFloat(import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE)
    : 1.0,
});

// pinia

import {createPinia} from 'pinia'
app.use(createPinia())

// router

import router from './router'
app.use(router)

// font-awesome

import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {
  faImages,
  faAnglesRight,
  faAnglesLeft,
  faGaugeHigh,
  faUserGear,
  faCaretRight,
  faCaretLeft,
  faCaretDown,
  faTimes,
  faPlus,
  faCircleCheck,
  faCircleExclamation,
  faGear,
  faDownload,
  faTriangleExclamation,
  faEllipsisVertical,
  faArrowRightToBracket,
  faCircleInfo,
  faCopy,
  faLock,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faFileInvoice,
  faCircleArrowUp,
} from '@fortawesome/free-solid-svg-icons'

import { faGoogle } from '@fortawesome/free-brands-svg-icons'

library.add(
  faImages,
  faAnglesRight,
  faAnglesLeft,
  faGaugeHigh,
  faUserGear,
  faCaretRight,
  faCaretLeft,
  faCaretDown,
  faTimes,
  faPlus,
  faCircleCheck,
  faCircleExclamation,
  faGear,
  faDownload,
  faTriangleExclamation,
  faEllipsisVertical,
  faArrowRightToBracket,
  faCircleInfo,
  faCopy,
  faLock,
  faArrowDownShortWide,
  faArrowDownWideShort,
  faFileInvoice,
  faCircleArrowUp,
  faGoogle
)

app.component('font-awesome-icon', FontAwesomeIcon)

// vue3-skeleton

import {Skeleton} from "@brayamvalero/vue3-skeleton"
import '@brayamvalero/vue3-skeleton/dist/style.css'
app.use(Skeleton)

// floating-vue

import {
  vTooltip,
  vClosePopper,
  Dropdown,
  Tooltip,
  Menu
} from 'floating-vue'
import 'floating-vue/dist/style.css'

app.directive('tooltip', vTooltip)
app.directive('close-popper', vClosePopper)

app.component('VDropdown', Dropdown)
app.component('VTooltip', Tooltip)
app.component('VMenu', Menu)

// vue-final-modal

import {createVfm} from "vue-final-modal";
import 'vue-final-modal/style.css'

const vfm = createVfm()
app.use(vfm)

// mount app

app.mount('#app')
